import React from 'react'

import { Text, TextName } from 'sdk/text/Text'

import { useWindowSize } from 'core/hooks/useWindowSize'
import type { SdkGetStartedCmsContent } from 'core/services/cms/interfaces'

import { DesktopCards } from './DesktopCards'
import { MobileCards } from './MobileCards'
import { SystemRequirementsAccordion } from './SystemRequirementsAccordion'
import { ResourceDownloadCards } from './ResourceDownloadCards'

import styles from './style.module.scss'

interface GetStartedSectionProps {
  content: SdkGetStartedCmsContent
}

export const GetStartedSection: React.FC<GetStartedSectionProps> = ({ content }) => {
  const { width } = useWindowSize()
  const isDesktop = width >= 1024

  const heading = (
    <Text type={TextName.H2} className={styles.heading}>
      {content.title}
    </Text>
  )

  return (
    <>
      {isDesktop ? (
        <DesktopCards heading={heading} steps={content.steps} />
      ) : (
        <MobileCards heading={heading} steps={content.steps} />
      )}
      <SystemRequirementsAccordion requirements={content.systemRequirements} />
      <ResourceDownloadCards cards={content.resourceCards} />
    </>
  )
}
